module.exports = __webpack_public_path__ + "img/四校戦 1.555606fe.jpg";